import(/* webpackMode: "eager" */ "/opt/dobrozem/apps/web/src/assets/img/default-image.jpg");
;
import(/* webpackMode: "eager" */ "/opt/dobrozem/apps/web/src/views/offer/OfferView/OfferView.tsx");
